export const validation = {
  title: "Title is required",
};
